import AvatarComp from "themes/elements/Avatar";
import style from "../../details.module.scss";

function Content(props) {
  const { selectedArticle } = props;

  return (
    <>
      {/* Article Image */}
      <span className={style["banner-image"]}>
        <img
          src={
            selectedArticle?.images[0]?.project_image
              ? selectedArticle?.images[0]?.project_image
              : "png/banner_articles.png"
          }
          alt=""
        />
      </span>
      <div className="flex flex-column gap-1">
        {/* Article abstract title */}
        <div className={style["details-des"]}>
          {selectedArticle?.description}
        </div>

        <div className={`${style["news-details"]} flex align-center gap-4`}>
          <div className={`flex align-center gap-1 ${style["details-left"]}`}>
            <div className="flex align-center gap-1">
              {/* author image */}
              {selectedArticle?.created_user_name &&
                (selectedArticle?.created_user_image ? (
                  <span className={style["avatar-img"]}>
                    <img
                      src={selectedArticle?.created_user_image}
                      alt={selectedArticle?.author?.slice(0, 4)}
                    />
                  </span>
                ) : (
                  <AvatarComp blue>
                    {selectedArticle?.created_user_name
                      ?.slice(0, 1)
                      .toUpperCase()}
                  </AvatarComp>
                ))}
              {selectedArticle?.created_user_name && (
                /* author name */
                <h6 className={style["details-text"]}>
                  {selectedArticle?.created_user_name}
                </h6>
              )}
            </div>
            {/* Seperator : dot */}
            {selectedArticle?.created_user_name && (
              <span className={style["details-dot"]}></span>
            )}
            {/* date */}
            {selectedArticle?.created_date && (
              <h6 className={style["details-text"]}>
                {selectedArticle?.created_date}
              </h6>
            )}
          </div>
          {/* News Source */}
          {selectedArticle?.read_time && (
            <h6 className={style["details-text"]}>
              {selectedArticle?.read_time}
            </h6>
          )}
        </div>
      </div>

      {/* Injected HTML content */}
      <div className={`${style["details-content"]} ${style.html}`}>
        <div
          style={{
            color: "white",
            overflow: "auto", // Inline style for the parent container
          }}
          dangerouslySetInnerHTML={{
            __html: selectedArticle?.project_content, // Injected HTML content
          }}
        />
      </div>
    </>
  );
}

export default Content;
